module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(this.$store.state.itensSla.controleExibicaoImpressao) ? _c('div', [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "items": _vm.evidenciasPorItem
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1df35d98!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/evidencia/print/EvidenciaImpressao.vue
// module id = 960
// module chunks = 1